import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { PageSection, CheckGrid, CTABand } from "../components/site/ContentBlocks";
import { FadeUp } from "../components/site/Reveal";
import { PRODUCT_PAGES } from "../data/content";

export default function SourcingProducts() {
    const vnProducts = PRODUCT_PAGES.filter((p) => p.id !== "oil-gas");
    return (
        <div className="grain bg-navy-deep" data-testid="sourcing-products-page">
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: "Sourcing Products from Vietnam | Rice, Seafood & Agricultural Products — Viet Medica Ltd",
                        description:
                            "Buy products from Vietnam — rice, seafood, dried fruits, nuts and agricultural products with supplier connections, samples and export support from Viet Medica Ltd.",
                        path: "/sourcing-products-from-vietnam",
                    }}
                    crumbs={[{ label: "International Trading", href: "/international-trading" }, { label: "Vietnam Sourcing", href: "/vietnam-sourcing-agent" }, { label: "Products" }]}
                    eyebrow="Trading and Sourcing from Vietnam"
                    title="Sourcing Products"
                    titleEm="from Vietnam."
                    copy="Viet Medica Ltd supports international buyers across selected Vietnamese product categories. Every requirement is reviewed individually — specifications, quantities, packaging, certifications and destination requirements are confirmed per enquiry."
                />

                {vnProducts.map((p, i) => (
                    <PageSection
                        key={p.id}
                        light={i % 2 === 0}
                        eyebrow={p.eyebrow}
                        title={p.title}
                        copy={p.intro}
                        testid={`sourcing-${p.id}`}
                    >
                        <CheckGrid items={p.points} light={i % 2 === 0} cols={3} />
                        <FadeUp delay={0.1}>
                            <Link
                                to={p.path}
                                data-testid={`sourcing-${p.id}-link`}
                                className={`mt-9 inline-flex items-center gap-2 border px-6 py-3.5 text-xs font-bold uppercase tracking-[0.18em] transition-colors ${
                                    i % 2 === 0
                                        ? "border-navy-deep/30 text-navy-deep hover:border-gold hover:text-gold"
                                        : "border-gold/50 text-gold hover:bg-gold hover:text-navy-deep"
                                }`}
                            >
                                More about {p.title}
                                <ArrowUpRight size={14} />
                            </Link>
                        </FadeUp>
                    </PageSection>
                ))}

                <PageSection eyebrow="Something Else?" title="Other Vietnam Products" testid="sourcing-other">
                    <FadeUp>
                        <p className="max-w-3xl text-base leading-relaxed text-slate-300/85 md:text-lg">
                            Looking for a product not shown here? Tell our Vietnam team what you need. We can
                            review the requirement and determine whether our local network may be able to assist.
                        </p>
                        <p className="mt-4 max-w-3xl text-sm leading-relaxed text-slate-500">
                            Product categories are confirmed individually. We do not list unconfirmed categories as
                            products currently supplied through Viet Medica Ltd.
                        </p>
                    </FadeUp>
                </PageSection>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <CTABand
                            title="Describe the product you need."
                            primary={{ label: "Send Product Requirement", to: "/vietnam-sourcing-enquiry", testid: "sourcing-products-cta" }}
                            secondary={{ label: "Vietnam Sourcing Process", to: "/vietnam-sourcing-agent", testid: "sourcing-process-cta" }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
